// Generated by Melange

import * as Fx from "../fx/fx.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as StoreFx__PlayerContext from "./playerContext.jsx";

function make(param) {
  return Fx.Monad_syntax.let$star(Fx.ask(undefined), (function (param) {
    const store = param.store;
    store.setState(function (prevState) {
      const init = prevState.player;
      return {
        albums: prevState.albums,
        artists: prevState.artists,
        auth: prevState.auth,
        player: {
          buffered: init.buffered,
          currentSongId: init.currentSongId,
          currentTime: init.currentTime,
          duration: init.duration,
          muted: !(prevState.player.muted || prevState.player.volume === 0.0),
          paused: init.paused,
          queuedSongIds: init.queuedSongIds,
          replayGainOptions: init.replayGainOptions,
          volume: prevState.player.muted && prevState.player.volume === 0.0 || prevState.player.volume === 0.0 ? 0.5 : prevState.player.volume
        },
        songs: prevState.songs
      };
    });
    return {
      TAG: /* Ok */ 0,
      _0: Stdlib__Option.iter((function (param) {
        const state = store.getState();
        param.volumeNode.gain.value = state.player.muted ? 0.0 : state.player.volume;
      }), StoreFx__PlayerContext.value.contents)
    };
  }));
}

export {
  make,
}
/* StoreFx__PlayerContext Not a pure module */
